import { collection, CollectionReference, doc, DocumentReference, query } from "@firebase/firestore";
import { ReactNode, useMemo } from "react";
import { DemoQuizData, OpenDataItem, OpenQuizData } from "src/db";
import { useDocumentSnapshot, useQuerySnapshot, useSnapshotData } from "src/firebase-util";
import { useSiteDoc } from "src/ui/getSite";

export function DemoQuizLoader({ children }: { children: (data: DemoQuizData) => ReactNode }) {
  const siteDoc = useSiteDoc();
  const document = useMemo(() => doc(siteDoc, "demo-quiz", "demo") as DocumentReference<OpenQuizData>, [siteDoc]);
  const data = useSnapshotData(useDocumentSnapshot(document));

  const sharedDataCollection = useMemo(
    () => query(collection(siteDoc, "shared") as CollectionReference<OpenDataItem>),
    [siteDoc]
  );
  const sharedDataSnapshot = useQuerySnapshot(sharedDataCollection);

  const sharedData = useMemo(() => {
    if (!sharedDataSnapshot) return null;
    return Object.fromEntries(sharedDataSnapshot.docs.map((snapshot) => [snapshot.data().id, snapshot.data().json]));
  }, [sharedDataSnapshot]);

  if (data === null || sharedData === null) return <>Fetching demo quiz...</>;

  return <>{children({ ...data, sharedData })}</>;
}
